<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import Sprite from "../sprite.svelte";

  export let canReroute = false;
  export let enabled = false;
  export let hasHazards = false;

  const dispatch = createEventDispatcher();
</script>

{#if hasHazards}
  <div class="Hazard">
    <span class="HazardTitle">
      <Sprite icon="icon-stairs" fill="#ffaa00" /> Path contains stairs
    </span>

    {#if canReroute}
      <button class="primary" type="button" on:click={() => dispatch("filter", true)}>
        Reroute
      </button>
    {/if}
  </div>
{:else if enabled}
  <div class="Hazard">
    <span class="HazardTitle">
      <Sprite icon="icon-detour" fill="#aaa" /> Avoiding paths with stairs
    </span>

    <button class="primary" type="button" on:click={() => dispatch("filter", false)}>
      Clear
    </button>
  </div>
{/if}

<style>
  .Hazard {
    background: #272727;
    position: absolute;
    bottom: var(--nav-height);
    color: white;
    font-size: 14px;
    align-items: center;
    left: 0;
    width: 100%;
    padding-inline-start: 10px;
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }

  .Hazard button {
    color: #ddd;
    cursor: pointer;
    align-self: stretch;
    padding-block: 0;
    padding-inline-end: 12px;
  }

  .HazardTitle {
    align-items: center;
    flex: 1 1;
    display: flex;
    padding-block: 8px;
    gap: 6px;
  }

  .HazardTitle :global(svg) {
    flex: 0 0 24px;
  }
</style>
